/** Customer-facing wording; never changes catalog identity, pricing, or grouping data. */
export function commercialLinePresentation(name: string | null | undefined, description: string | null | undefined, catalogDescription?: string | null) {
  const originalName = name?.trim() || '';
  const detail = description?.trim() || '';
  const catalogDetail = catalogDescription?.trim() || '';
  const hvacLabor = /^hvac$/i.test(originalName) && (/^labor$/i.test(detail) || /^labor$/i.test(catalogDetail));
  const title = hvacLabor ? 'HVAC Labor' : originalName;
  let summary = detail === originalName ? catalogDetail : detail;
  if (summary === title || (hvacLabor && /^labor$/i.test(summary))) summary = '';
  return { name: title, description: summary };
}
